<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
							№ {{ id }}
						</v-col>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
							{{ item.datecreate | formatDateTime }}
						</v-col>
						<v-col cols="12" class="text-right">
							{{ username }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" flat v-for="(estimate, index) in estimates" :key="index">
					<!-- <z-form-average-price-statistic :estimate="estimate"></z-form-average-price-statistic> -->
					<!-- <div class="text-subtitle-1 font-weight-bold">Оцінка ринку</div> -->

					<div>
						<!-- <div class="text-subtitle-1 font-weight-bold">{{ estimate.name }}</div> -->
						<div class="text-subtitle-1 font-weight-bold">Статистика</div>
						<!-- <v-simple-table dense>
							<template v-slot:default>
								<tbody>
									<tr>
										<td width="50%">UAH</td>
										<td>{{ estimate.avgPriceUAH | toMoney }}</td>
									</tr>
									<tr>
										<td>USD</td>
										<td>{{ estimate.avgPriceUSD | toMoney }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table> -->
						<v-row v-if="estimate.prices.length">
							<v-col cols="12" md="6">
								<div>
									<v-subheader>Середня ціна</v-subheader>
									<v-simple-table dense>
										<template v-slot:default>
											<tbody>
												<tr>
													<td>UAH</td>
													<td class="d-flex justify-end">{{ avgUAH(estimate.prices) | toMoney }}</td>
												</tr>
												<tr>
													<td>USD</td>
													<td class="d-flex justify-end">{{ avgUSD(estimate.prices) | toMoney }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</div>
							</v-col>

							<v-col cols="12" md="3">
								<div>
									<v-subheader>Мінімальна ціна</v-subheader>
									<v-simple-table dense>
										<template v-slot:default>
											<tbody>
												<tr>
													<td>UAH</td>
													<td class="d-flex justify-end">{{ minUAH(estimate.prices) | toMoney }}</td>
												</tr>
												<tr>
													<td>USD</td>
													<td class="d-flex justify-end">{{ minUSD(estimate.prices) | toMoney }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</div>
							</v-col>

							<v-col cols="12" md="3">
								<div>
									<v-subheader>Максимальна ціна</v-subheader>
									<v-simple-table dense>
										<template v-slot:default>
											<tbody>
												<tr>
													<td>UAH</td>
													<td class="d-flex justify-end">{{ maxUAH(estimate.prices) | toMoney }}</td>
												</tr>
												<tr>
													<td>USD</td>
													<td class="d-flex justify-end">{{ maxUSD(estimate.prices) | toMoney }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</div>
							</v-col>
							<v-col cols="12">
								<div>
									<v-subheader>За періодами</v-subheader>
									<v-simple-table dense>
										<template v-slot:default>
											<thead>
												<tr>
													<th>Дата</th>
													<th>Вартість в UAH</th>
													<th>Вартість в USD</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in estimate.prices" :key="index">
													<td >{{ item.name }}</td>
													<td >{{ item.priceUAH | toMoney }}</td>
													<td >{{ item.priceUSD | toMoney }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</div>
							</v-col>
						</v-row>
					</div>
				</div>

				<!-- <z-form-vehicle-estimate-calculation :item="item"></z-form-vehicle-estimate-calculation> -->
				<!-- <z-form-vehicle-estimate-conclusion :item="item"></z-form-vehicle-estimate-conclusion> -->
				<!-- <div class="html2pdf__page-break" v-if="factors.length"></div> -->
				<div class="html2pdf__page-break"/>

				<div class="mx-8" v-if="factors.length">
					<div class="text-subtitle-1 font-weight-bold">Розрахунок вартості</div>
					<div class="text-subtitle-2">На основі аналізу довідкових даних щодо даного транспортного засобу встановлені такі показники:</div>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th width="50%" class="text-left">Показник</th>
									<th width="10%" class="text-left">Умовне позначення</th>
									<th width="10%" class="text-left">Значення</th>
									<th width="30%" class="text-left">Опис</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in factors" :key="item.id" >
									<td>{{ item.name }}</td>
									<td>{{ item.code }}</td>
									<td>{{ item.val }}</td>
									<td>{{ item.description }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>


				<div class="mx-8" v-if="item.hasOwnProperty('costAmvUAH')">
					<div class="text-subtitle-1 font-weight-bold">Висновок</div>
					<!-- <div class="text-button">Висновок</div> -->
					<v-simple-table>
						<template v-slot:default>
							<tbody>
								<tr>
									<td width="70%">Середньоринкова вартість ТЗ становить:</td>
									<td class="d-flex justify-end align-center">{{ item.costAmvUAH }} грн.</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

import zFormAveragePriceStatistic from '@/views/forms/VehicleAveragePriceStatistic'
import zFormVehicleEstimateCalculation from '@/views/forms/VehicleEstimateCalculation'
import zFormVehicleEstimateConclusion from '@/views/forms/VehicleEstimateConclusion'

export default {
	mixins: [mixin],
	components: { VueHtml2pdf,
		//zFormAveragePriceStatistic, zFormVehicleEstimateCalculation, zFormVehicleEstimateConclusion
	},
	data: () => ({
		
	}),

	computed: {
		factors() {
			return this.item.hasOwnProperty('factors') ? this.item.factors: [];
		},

		/* prices() {
			return this.estimate.hasOwnProperty('prices') ? this.estimate.prices: [];
		}, */
	},

	methods: {
		labels(items) {
			return items.map(element=>element.name);
		},

		valueUAH(items) {
			return items.map(element=>element.priceUAH);
		},

		valueUSD(items) {
			return items.map(element=>element.priceUSD);
		},

		avgUAH(items) {
			const arr = this.valueUAH(items);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average
		},

		avgUSD(items) {
			const arr = this.valueUSD(items);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average
		},

		minUAH(items) {
			const arr = this.valueUAH(items);
			return Math.min(...arr)
		},
		minUSD(items) {
			const arr = this.valueUSD(items);
			return Math.min(...arr)
		},

		maxUAH(items) {
			const arr = this.valueUAH(items);
			return Math.max(...arr)
		},
		maxUSD(items) {
			const arr = this.valueUSD(items);
			return Math.max(...arr)
		},
	},
}

</script>